<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-back
        @back="returnBack()"
        :title="['互动广场']"
        :subTitle="activityData.name"
        style="padding-bottom: 0"
      ></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <jd-tip style="margin-bottom: 10px"
          >云短信CRM ：订购到期时间
          {{ jdCrm.endTime }}（店铺需要搭配云短信CRM使用）。</jd-tip
        >
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="backgroundForm"
          label-width="150px"
        >
          <!-- 基本信息 -->
          <informationForm
            @selectPeopleSure="selectPeopleSure"
            :defaultActMember.sync="actMember"
            :defaultActivityStartTime.sync="activityStartTime"
            :defaultActivityEndTime.sync="activityEndTime"
            :plusObject.sync="ruleDTO.plusObject"
            :openCardStartTime.sync="ruleDTO.openCardStartTime"
            :openCardEndTime.sync="ruleDTO.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            ref="informationForm"
            v-model="ruleForm"
            :isEdit="false"
            :isNeedCusType="true"
            :cusType.sync="ruleDTO.cusType"
            :disabled="activityData.isStart"
            :localStepNum="localStepNum"
            :activityId="84"
            :showOpenCardTip="true"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <!-- 活动设置 -->
          <jd-title label="活动设置"></jd-title>
          <div class="mt20">
            <el-form-item label="打卡类型：" required>
              <div style="display: flex">
                <el-checkbox-group
                  @change="checkListChange"
                  v-model="ruleDTO.signTypes"
                  :disabled="isStartEdit"
                >
                  <el-checkbox :label="0">单次打卡</el-checkbox>
                  <el-checkbox :label="1">每日打卡</el-checkbox>
                  <el-checkbox :label="2">指定打卡</el-checkbox>
                  <el-checkbox :label="3">累计打卡</el-checkbox>
                  <el-checkbox :label="4">连续打卡</el-checkbox>
                </el-checkbox-group>
                <el-tooltip placement="top">
                  <template #content>
                    <div>
                      打卡类型有5种，支持多选，多选则表示同时满足多种打卡类型时，奖品可配置优先级或同时兼得：
                    </div>
                    <div>
                      1、单次打卡：活动时间范围内，完成一次打卡即可获得相应奖品；
                    </div>
                    <div>
                      2、每日打卡：活动时间范围内，每日完成打卡都可获得相应奖品；
                    </div>
                    <div>
                      3、指定打卡：活动时间范围内，指定日期完成打卡才能获得相应奖品；
                    </div>
                    <div>
                      4、累计打卡：活动时间范围内，只有累计完成指定打卡天数才能获得相应奖品；
                    </div>
                    <div>
                      5、连续打卡：活动时间范围内，必须连续不间断完成指定打卡天数才能获得相应奖品；
                    </div>
                  </template>
                  <div style="margin-left: 12px; color: #3159ff">
                    <span>打卡类型说明</span>
                    <i class="new-icon-box cursorPointer ml8"></i>
                  </div>
                </el-tooltip>
              </div>
            </el-form-item>
            <el-form-item label="打卡模式：">
              <el-radio-group
                v-model="ruleDTO.signPattern"
                @change="signPatternChange"
                :disabled="isStartEdit"
              >
                <el-radio :label="0">图文打卡</el-radio>
                <el-radio :label="1">签到打卡</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="" v-if="ruleDTO.signPattern == 0">
              <div class="prize-box">
                <el-form-item label="是否需要审核:">
                  <el-radio-group
                    v-model="ruleDTO.isCheck"
                    :disabled="isStartEdit"
                  >
                    <el-radio :label="0">无需审核</el-radio>
                    <el-radio :label="1"
                      >需要商家审核（表示用户上传的图片等资料需要商家审核通过后才算参与成功）</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="设置必填项:">
                  <el-checkbox-group
                    v-model="ruleDTO.mustOpt"
                    :disabled="isStartEdit"
                  >
                    <el-checkbox :disabled="true" :label="0"
                      >图片/视频</el-checkbox
                    >
                    <el-checkbox :label="1">文案</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="关联店铺:" required>
                  <orderShopCom
                    :venderIds.sync="ruleDTO.venderIds"
                    :multiShopGoods.sync="multiShopGoods"
                    :sellerSkuList.sync="ruleDTO.sellerSkuList"
                    :isDisabled="activityData.isStart"
                    @changeShop="changeShop"
                  />
                  <jdTab
                    :tabsList="shopList"
                    :fatherTabAct="multiShopId"
                    @tab-click="getShopList"
                  />
                  <jd-button type="blue" @click="addProduct"
                    >添加商品（{{ newGoodsList.length }}/20）</jd-button
                  >
                  <frontPageTable
                    :productList="newGoodsList"
                    :headerCellStyle="{
                      'text-align': 'center',
                      'border-bottom': '2px solid #EBEEF5',
                      background: '#FAFAFA',
                    }"
                    :cellStyle="{ 'text-align': 'center', overflow: 'visible' }"
                    :tableStyle="'width: 920px; overflow: visible; margin-top: 15px'"
                    :paginationStyle="'width: 920px; overflow: visible; margin-top: 15px;display: flex;justify-content: end;'"
                  >
                    <template #tableContent>
                      <el-table-column prop="productImage" label="商品图片">
                        <template slot-scope="scope">
                          <div class="product-image-cell">
                            <img
                              v-if="scope.row.logo"
                              :src="scope.row.logo"
                              class="product-thumb"
                            />
                            <div v-else class="product-placeholder">
                              商品图片
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="skuName"
                        label="商品名称"
                      ></el-table-column>
                      <el-table-column
                        prop="jdPrice"
                        label="商品价格（元）"
                      ></el-table-column>
                      <el-table-column
                        prop="skuId"
                        label="skuId"
                      ></el-table-column>
                      <el-table-column label="操作">
                        <template slot-scope="scope">
                          <jd-button
                            type="blueText"
                            @click="deleteProduct(scope.$index)"
                            >删除</jd-button
                          >
                        </template>
                      </el-table-column>
                    </template>
                  </frontPageTable>
                  <div class="mt16">
                    <el-checkbox
                      :disabled="isStartEdit"
                      :true-label="1"
                      :false-label="0"
                      v-model="ruleDTO.isMustBuy"
                      >用户必须购买过指定商品，才可以参与活动（不勾选则表示没有购买过指定商品也可参与）</el-checkbox
                    >
                  </div>
                </el-form-item>
                <el-form-item
                  label="下单时间:"
                  v-if="ruleDTO.isMustBuy == 1"
                  required
                >
                  <div class="apply-time-form-item">
                    用户在
                    <div class="my_select_time">
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleDTO.orderStartTime"
                        type="datetime"
                        placeholder="开始日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        default-time="00:00:00"
                        style="width: 185px; font-size: 12px"
                        class="time1"
                        :picker-options="orderStartTimePicker"
                        :disabled="isStartEdit"
                        :clearable="false"
                      >
                      </el-date-picker>
                      <div class="time_to_text">至</div>
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleDTO.orderEndTime"
                        type="datetime"
                        placeholder="结束日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        default-time="23:59:59"
                        style="width: 200px; font-size: 12px"
                        class="time2"
                        :picker-options="orderEndTimePicker"
                        :disabled="isStartEdit"
                        :clearable="false"
                      >
                      </el-date-picker>
                      <i
                        class="el-icon-circle-close date_icon1"
                        v-if="!activityData.isStart"
                        @click="
                          ruleDTO.orderStartTime = '';
                          ruleDTO.orderEndTime = '';
                        "
                      ></i>
                      <img
                        src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                        alt=""
                        class="date_icon2"
                      />
                    </div>
                    <span style="margin-left: 8px">期间内下单</span>&nbsp;
                    <jd-button
                      type="blueText"
                      @click="synchronization"
                      :disabled="isStartEdit"
                      >同步活动时间</jd-button
                    >
                  </div>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item label="前置曝光加购商品：">
              <div class="flexc-cen-x">
                <el-checkbox
                  v-model="ruleDTO.isAddBuyItem"
                  :disabled="backgroundOpacity"
                  @change="handleFirstItemSwitchChange"
                >
                  是否开启加购商品
                </el-checkbox>
                <el-tooltip placement="top">
                  <template #content>
                    <div>
                      1、开启配置，会影响活动页-奖品区域布局，左边预留【商品曝光】位置
                    </div>
                    <div>2、C端每日曝光商品按此配置顺序每日轮播</div>
                    <div>
                      3、进行中修改前置曝光商品后，C端活动页将从列表首位重新开始轮播
                    </div>
                  </template>
                  <div class="mt4">
                    <i class="new-icon-box cursorPointer ml8"></i>
                  </div>
                </el-tooltip>
              </div>
            </el-form-item>
            <el-form-item
              label="关联店铺:"
              required
              v-if="ruleDTO.signPattern == 1 && ruleDTO.isAddBuyItem"
            >
              <orderShopCom
                :venderIds.sync="ruleDTO.venderIds"
                :multiShopGoods.sync="multiShopGoods"
                :sellerSkuList.sync="ruleDTO.sellerSkuList"
                :isDisabled="activityData.isStart"
                @changeShop="changeShop"
              />
            </el-form-item>
            <exposureList
              v-model="firstItemList"
              :defaultExposureSwitch.sync="ruleDTO.isAddBuyItem"
              :multiShopSkuType.sync="ruleDTO.firstOpenCardTimeType"
              :multiShopGoods="multiShopGoods"
              :skuBelongVenderId="ruleDTO.firstAddBuySkuBelongVenderId"
              :backgroundOpacity="backgroundOpacity"
              :isShowExposure="false"
              :isLimit="true"
              :limitNum="10"
              :isEdit="isCreated"
            ></exposureList>
          </div>
          <!-- 奖品设置 -->
          <jd-title
            label="打卡奖品设置"
            v-if="ruleDTO.signTypes.length > 0"
          ></jd-title>
          <div class="mt20">
            <div v-for="(item, index) in tableSequenceConfig" :key="index">
              <el-form-item
                :label="`${item}：`"
                v-if="
                  (item == '单次打卡奖品' && ruleDTO.signTypes.includes(0)) ||
                  (item == '每日打卡奖品' && ruleDTO.signTypes.includes(1)) ||
                  (item == '指定日期打卡奖品' &&
                    ruleDTO.signTypes.includes(2)) ||
                  (item == '累计打卡奖品' && ruleDTO.signTypes.includes(3)) ||
                  (item == '连续打卡奖品' && ruleDTO.signTypes.includes(4))
                "
              >
                <div>
                  <template v-if="item == '单次打卡奖品'">
                    <newPrizeTable
                      :prizeList.sync="oneTimeList"
                      indexLabel="排序"
                      :isDisabled="activityData.isStart"
                      :tableInfo="oneTimeTableInfo"
                      :valueRow="valueRow"
                      :isShowUpLoadBtn="true"
                      :actType="84"
                      otherKey="calenderCheckCardType"
                      :actEndTime="ruleForm.endTime"
                    >
                      <template #dailyLimitName="{ scopeRow }">
                        <dailyLimitConfig
                          :row="scopeRow"
                          :backgroundOpacity="backgroundOpacity"
                          :limitBtnDisabled="backgroundOpacity"
                        ></dailyLimitConfig>
                      </template>
                    </newPrizeTable>
                  </template>
                  <template v-if="item == '每日打卡奖品'">
                    <newPrizeTable
                      :prizeList.sync="dayTimeList"
                      indexLabel="排序"
                      :isDisabled="activityData.isStart"
                      :tableInfo="oneTimeTableInfo"
                      :valueRow="valueRow"
                      :isShowUpLoadBtn="true"
                      :actType="84"
                      otherKey="calenderCheckCardType"
                      :actEndTime="ruleForm.endTime"
                    >
                      <template #dailyLimitName="{ scopeRow }">
                        <dailyLimitConfig
                          :row="scopeRow"
                          :backgroundOpacity="backgroundOpacity"
                          :limitBtnDisabled="backgroundOpacity"
                        ></dailyLimitConfig>
                      </template>
                    </newPrizeTable>
                  </template>
                  <template v-if="item == '指定日期打卡奖品'">
                    <newPrizeTable
                      :prizeList.sync="specifiedDateList"
                      indexLabel="排序"
                      :isDisabled="activityData.isStart"
                      :tableInfo="specifiedDateTableInfo"
                      :valueRow="valueRow"
                      :isShowUpLoadBtn="true"
                      :isShowAdd="true"
                      :isShowReset="true"
                      :isShowMoveBtn="true"
                      :maxPrizeCount="10"
                      :actType="84"
                      otherKey="calenderCheckCardType"
                      :actEndTime="ruleForm.endTime"
                      @addPrize="addSpecifiedDateList"
                    >
                      <template #dateName="{ scopeRow, scopeIndex }">
                        <el-date-picker
                          v-model="scopeRow.calenderCheckCardSpecifiedDate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="请选择日期"
                          :picker-options="pickerOptionsValue" 
                          :disabled="activityData.isStart"
                          style="width: 140px"
                        />
                      </template>
                      <template #dailyLimitName="{ scopeRow }">
                        <dailyLimitConfig
                          :row="scopeRow"
                          :backgroundOpacity="backgroundOpacity"
                          :limitBtnDisabled="backgroundOpacity"
                        ></dailyLimitConfig>
                      </template>
                    </newPrizeTable>
                  </template>
                  <template v-if="item == '累计打卡奖品'">
                    <newPrizeTable
                      :prizeList.sync="cumulativeCheckiInList"
                      indexLabel="排序"
                      :isDisabled="activityData.isStart"
                      :tableInfo="cumulativeCheckiInTableInfo"
                      :valueRow="valueRow"
                      :isShowUpLoadBtn="true"
                      :isShowAdd="true"
                      :isShowReset="true"
                      :isShowMoveBtn="true"
                      :maxPrizeCount="10"
                      :actType="84"
                      otherKey="calenderCheckCardType"
                      :actEndTime="ruleForm.endTime"
                      @addPrize="addCumulativeCheckInList"
                    >
                      <template
                        #cumulativeCheckiInName="{ scopeRow, scopeIndex }"
                      >
                        <div class="flexc-center-x">
                          <span>累计打卡 </span>
                          <el-input
                            class="w100 mlr8"
                            v-model="scopeRow.calenderCheckCardTimes"
                            placeholder="请输入"
                            @input="
                              scopeRow.calenderCheckCardTimes = getNumberData(
                                1,
                                $event,
                                0,
                                1,
                                999999
                              )
                            "
                          />
                          <span>天</span>
                        </div>
                      </template>
                      <template #dailyLimitName="{ scopeRow }">
                        <dailyLimitConfig
                          :row="scopeRow"
                          :backgroundOpacity="backgroundOpacity"
                          :limitBtnDisabled="backgroundOpacity"
                        ></dailyLimitConfig>
                      </template>
                    </newPrizeTable>
                  </template>
                  <template v-if="item == '连续打卡奖品'">
                    <newPrizeTable
                      :prizeList.sync="continuousCheckInList"
                      indexLabel="排序"
                      :isDisabled="activityData.isStart"
                      :tableInfo="continuousCheckiInTableInfo"
                      :valueRow="valueRow"
                      :isShowUpLoadBtn="true"
                      :isShowAdd="true"
                      :isShowReset="true"
                      :isShowMoveBtn="true"
                      :maxPrizeCount="10"
                      :actType="84"
                      otherKey="calenderCheckCardType"
                      @addPrize="addContinuousCheckInList"
                      :actEndTime="ruleForm.endTime"
                    >
                      <template
                        #cumulativeCheckiInName="{ scopeRow, scopeIndex }"
                      >
                        <div class="flexc-center-x">
                          <span>连续打卡 </span>
                          <el-input
                            class="w100 mlr8"
                            v-model="scopeRow.calenderCheckCardTimes"
                            placeholder="请输入"
                            @input="
                              scopeRow.calenderCheckCardTimes = getNumberData(
                                1,
                                $event,
                                0,
                                1,
                                999999
                              )
                            "
                          />
                          <span>天</span>
                        </div>
                      </template>
                      <template #dailyLimitName="{ scopeRow }">
                        <dailyLimitConfig
                          :row="scopeRow"
                          :backgroundOpacity="backgroundOpacity"
                          :limitBtnDisabled="backgroundOpacity"
                        ></dailyLimitConfig>
                      </template>
                    </newPrizeTable>
                  </template>
                </div>
              </el-form-item>
            </div>
          </div>
          <jd-title label=" 补卡任务设置"></jd-title>
          <div class="mt20">
            <el-form-item label="是否开启补卡：">
              <el-checkbox
                :disabled="isStartTaskForReSignNumDisabled || backgroundOpacity"
                :true-label="1"
                :false-label="0"
                v-model="ruleDTO.isStartTaskForReSignNum"
                @change="changeReSignNum"
                >开启做任务获得补签卡（开启后需要设置任务，表示用户可以通过完成指定任务获取补签卡，进行补签）</el-checkbox
              >
            </el-form-item>
            <el-form-item
              v-if="ruleDTO.isStartTaskForReSignNum == 1"
              label="可补签天数："
            >
              <div style="display: flex; align-items: center">
                <el-input
                  :disabled="backgroundOpacity"
                  @input="
                    ruleDTO.reSignNum = getNumberData(1, $event, 0, 1, 999999)
                  "
                  v-model.number="ruleDTO.reSignNum"
                  style="width: 90px"
                  type="number"
                  placeholder="请输入"
                />
                <span class="ml4 tip-style">天</span>
                <span class="ml8 tip-style">不配置等于不限制可补签天数</span>
              </div>
            </el-form-item>
            <el-form-item
              label="补卡设置："
              required
              v-if="ruleDTO.isStartTaskForReSignNum == 1"
            >
              <taskComponent
                :taskList.sync="taskDataList"
                :taskOrders.sync="taskOrderList"
                :copySteList.sync="taskLevelList"
                :mainText="mainText"
                :unit="unit"
                :isTrueEdit="true"
                :isShowUnit="isShowUnit"
                :activityData="activityData"
                :activityStartTime="activityStartTime"
                :activityEndTime="activityEndTime"
                :hasSelectGoods="hasSelectGoods"
              />
            </el-form-item>
          </div>
          <!-- 活动页设置 -->
          <activityPageSettings
            isShowShopName
            isShowMoreSet
            :isShowShopNameByChannel="true"
            :cusTemplateJSON.sync="ruleDTO.cusTemplateJSON"
            :isNeedSetBG="true"
            :giftList="giftList"
            :templateId="templateId"
            :isShowDesignNumber="false"
            previewKey="url"
            templatekey="imageUrl"
            :widthNumber="750"
            :heightNumber="1950"
            :isCustomPreview="true"
            :downloadTemplateUrl="templateUrl"
            designSpecificationsUrl="https://cdn-image.yucrm.cn/images/dy/formTeamToShare/sjgfrldk.png"
            themeTitle="主题"
            :defaultRgb="currrentRgb"
            v-model="customerPaperwork"
            @selectTemplate="selectTemplate"
          >
            <template #customPreview>
              <calendarCheckInDialog
                :ruleForm="ruleForm"
                :ruleDTO="ruleDTO"
                :backgroundImage="backgroundImage"
                :customerPaperwork="customerPaperwork"
                :templateObj="templateObj"
                :oneTimeList="oneTimeList"
                :dayTimeList="dayTimeList"
                :specifiedDateList="specifiedDateList"
                :cumulativeCheckiInList="cumulativeCheckiInList"
                :continuousCheckInList="continuousCheckInList"
                :firstItemList="firstItemList"
              />
            </template>
            <template #otherSet>
              <customUpload
                :customerPaperwork="customerPaperwork"
                bgKey="url3"
                labelWidth="150px"
                :pw="100"
                :ph="100"
                labelText="打卡记录图:"
                bgLabelText="打卡记录图"
                :backgroundOpacity="backgroundOpacity"
              />
              <el-form-item label="签到按钮设置:">
                <div class="upload-box">
                  <btnSet
                    :customerData="customerPaperwork"
                    bgKey="url2"
                    colorKey="signBtnColor"
                    :pw="580"
                    :ph="94"
                    labelText="签到按钮背景图"
                    :backgroundOpacity="backgroundOpacity"
                    :resetColor="currrentRgb2"
                  />
                </div>
              </el-form-item>
              <el-form-item label="领奖按钮设置:">
                <div class="upload-box">
                  <btnSet
                    :customerData="customerPaperwork"
                    bgKey="url4"
                    labelWidth="120px"
                    colorKey="prizeBtnColor"
                    :pw="176"
                    :ph="62"
                    labelText="领奖按钮背景图"
                    bgLabelText="背景（无曝光）"
                    :backgroundOpacity="backgroundOpacity"
                    :resetColor="currrentRgb3"
                  >
                    <template>
                      <customUpload
                        :customerPaperwork="customerPaperwork"
                        bgKey="url5"
                        labelWidth="120px"
                        :pw="168"
                        :ph="46"
                        labelText="背景（曝光）："
                        bgLabelText="领奖按钮背景图"
                        :backgroundOpacity="backgroundOpacity"
                      />
                    </template>
                  </btnSet>
                </div>
              </el-form-item>
            </template>
          </activityPageSettings>
          <exposureList
            :defaultExposureSwitch.sync="ruleForm.isExposureItem"
            v-model="itemListFor"
            :backgroundOpacity="backgroundOpacity"
            :isLimit="true"
            :isEdit="isCreated"
            :multiShopSkuType.sync="ruleDTO.multiShopSkuType"
            :multiShopGoods="multiShopGoods"
            :skuBelongVenderId="ruleDTO.skuBelongVenderId"
          ></exposureList>
          <sharFrom :sharePic="sharePic" v-model="ruleDTO"></sharFrom>
          <activityRules
            :isForceRemind.sync="isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            v-model="ruleForm.ruleDescription"
            @generateRule="generateRule"
            :activityData="activityData"
            :valueRow="valueRow"
          ></activityRules>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button
        v-if="localStepNum != 0"
        style="margin-right: 8px"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button v-if="isSave" type="blue" @click="resetForm" v-preventReClick
          >保存设置</jd-button
        >
      </template>
    </div>

    <!-- 保存设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div v-loading="saveLoading">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>

        <el-checkbox v-model="checked" label="地址" name="partner"
          >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          v-loading="saveLoading"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
    <!-- 关联店铺 -->
    <selectGoodsMonitor
      v-if="isShowSelect"
      ref="selectGoFilterOne"
      :isShow="isShowSelect"
      @close="selectGoodsCloseFilter"
      :selectGoods="selectGoodsFilterArr"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="true"
      :venderId="multiShopId"
      :disabled="backgroundOpacity"
    ></selectGoodsMonitor>
  </div>
</template>

<script>
import {
  saveOrUpdateCalendarCheckIn,
  getCalendarCheckInDetail,
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import { sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import informationForm from "./components/informationForm.vue";
import exposureList from "./components/exposureList.vue";
import sharFrom from "./components/sharFrom.vue";
import activityRules from "./components/activityRules.vue";
import activityPageSettings from "./components/activityPageSettings.vue";
import calendarCheckInDialog from "./components/newActPreviews/calendar-checkIn-dialog.vue";
import newPrizeTable from "./components/newPrizeTable/index.vue";
import taskComponent from "./components/_components/taskComponent.vue";
import btnSet from "./components/commCustomizationSet/btnSet.vue";
import orderShopCom from "@/views/interactiveMarketing/activity/components/multipleStoreSetting/orderShopCom.vue";
import {
  useInputTaskData,
  useOutputTaskData,
} from "./components/commDataHook/useTaskData.js";
import {
  useOutputBasicInformation,
  useInputBasicInformation,
  useUpdateBasicInformation,
  useValidateBasicInformation,
  useValidatePrizeInformation,
  useValidateActEndInfomation,
} from "./components/commDataHook/useBasicInformation.js";
import { useJdCrm } from "./components/commDataHook/useCommReq.js";
import { useValidateMultiShopGoods } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
import frontPageTable from "./components/frontPageTable.vue";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import customUpload from "./components/commCustomizationSet/customUpload.vue";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
export default {
  components: {
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    calendarCheckInDialog,
    taskComponent,
    newPrizeTable,
    btnSet,
    orderShopCom,
    frontPageTable,
    selectGoodsMonitor,
    customUpload,
    dailyLimitConfig,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isStartTaskForReSignNumDisabled:false,
      pickerOptionsValue: {
				disabledDate: (time) => {
					if (this.ruleForm.startTime && this.ruleForm.endTime) {
						return new Date(this.ruleForm.startTime).getTime() - 8.64e7 > time.getTime() || time.getTime() > new Date(this.ruleForm.endTime).getTime();
					} else { }
				},
			},
      isShowSelect: false,
      selectGoodsFilterArr: [],
      multiShopId: "",
      jdCrm: {
        endTime: "",
      },
      isDisabledTotal: true,
      limitNum: 20,
      isIndex: false,
      isShowCustom: true,
      mainText: "补签卡",
      // otherUnit: "分",
      unit: "张",
      hasSelectGoods: [],
      isShowUnit: false,
      taskLevelList: [],
      isShowMoveBtn: true,
      oneTimeList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          singleAmount: "",
          calenderCheckCardType: 0,
        },
      ],
      dayTimeList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          singleAmount: "",
          calenderCheckCardType: 1,
        },
      ],
      specifiedDateList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          singleAmount: "",
          calenderCheckCardSpecifiedDate: "",
          calenderCheckCardType: 2,
        },
      ],
      cumulativeCheckiInList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          singleAmount: "",
          calenderCheckCardTimes: "",
          calenderCheckCardType: 3,
        },
      ],
      continuousCheckInList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          singleAmount: "",
          calenderCheckCardTimes: "",
          calenderCheckCardType: 4,
        },
      ],
      taskDataList: [], //任务列表
      taskOrderList: [],
      isLimit: true,
      oneTimeTableInfo: [
        {
          label: "奖品类型",
          prop: "prizeType",
          slot: "prizeTypeSlot",
        },
        {
          label: "值",
          prop: "price",
        },
        {
          label: "奖品名称（12字以内）",
          prop: "title",
          slot: "titleSlot",
          slotHead: "titleHeader",
        },
        {
          label: "奖品数量",
          prop: "totalAmount",
          slotHead: "totalAmountHeader",
          slot: "totalAmountSlot",
        },
        {
          label: "每日发放限额",
          slotName: "dailyLimitName",
          slot: "dailyLimit",
        },
        {
          label: "奖品图片",
          prop: "logo",
          slot: "logoSlot",
        },
        {
          label: "操作",
          prop: "operation",
          slot: "operationSlot",
          fixed: "right",
        },
      ],
      specifiedDateTableInfo: [
        {
          label: "日期",
          prop: "calenderCheckCardSpecifiedDate",
          slot: "dateSlot",
          slotName: "dateName",
          minWidth: 135,
        },
        {
          label: "奖品类型",
          prop: "prizeType",
          slot: "prizeTypeSlot",
          minWidth: 100,
        },
        {
          label: "值",
          prop: "price",
          minWidth: 100,
        },
        {
          label: "奖品名称（12字以内）",
          prop: "title",
          slot: "titleSlot",
          slotHead: "titleHeader",
          minWidth: 160,
        },
        {
          label: "奖品数量",
          prop: "totalAmount",
          slot: "totalAmountSlot",
          slotHead: "totalAmountHeader",
          minWidth: 120,
        },
        {
          label: "每日发放限额",
          slotName: "dailyLimitName",
          slot: "dailyLimit",
          width: 120,
        },
        {
          label: "奖品图片",
          prop: "logo",
          slot: "logoSlot",
          minWidth: 100,
        },
        {
          fixed: "right",
          label: "操作",
          prop: "operation",
          slot: "operationSlot",
          width: 280,
        },
      ],
      cumulativeCheckiInTableInfo: [
        {
          label: "累计打卡天数",
          prop: "calenderCheckCardTimes",
          slot: "cumulativeCheckiInSlot",
          slotName: "cumulativeCheckiInName",
          minWidth: 200,
        },
        {
          label: "奖品类型",
          prop: "prizeType",
          slot: "prizeTypeSlot",
          minWidth: 120,
        },
        {
          label: "值",
          prop: "price",
          minWidth: 100,
        },
        {
          label: "奖品名称（12字以内）",
          prop: "title",
          slot: "titleSlot",
          slotHead: "titleHeader",
          minWidth: 160,
        },
        {
          label: "奖品数量",
          prop: "totalAmount",
          slotHead: "totalAmountHeader",
          slot: "totalAmountSlot",
          minWidth: 100,
        },
        {
          label: "每日发放限额",
          slotName: "dailyLimitName",
          slot: "dailyLimit",
          minWidth: 120,
        },
        {
          label: "奖品图片",
          prop: "logo",
          slot: "logoSlot",
          minWidth: 120,
        },
        {
          fixed: "right",
          label: "操作",
          prop: "operation",
          slot: "operationSlot",
          width: 280,
        },
      ],
      continuousCheckiInTableInfo: [
        {
          label: "连续打卡天数",
          prop: "calenderCheckCardTimes",
          slot: "cumulativeCheckiInSlot",
          slotName: "cumulativeCheckiInName",
          minWidth: 200,
        },
        {
          label: "奖品类型",
          prop: "prizeType",
          slot: "prizeTypeSlot",
          minWidth: 120,
        },
        {
          label: "值",
          prop: "price",
          minWidth: 100,
        },
        {
          label: "奖品名称（12字以内）",
          prop: "title",
          slot: "titleSlot",
          slotHead: "titleHeader",
          minWidth: 160,
        },
        {
          label: "奖品数量",
          prop: "totalAmount",
          slotHead: "totalAmountHeader",
          slot: "totalAmountSlot",
          minWidth: 100,
        },
        {
          label: "每日发放限额",
          slotName: "dailyLimitName",
          slot: "dailyLimit",
          minWidth: 120,
        },
        {
          label: "奖品图片",
          prop: "logo",
          slot: "logoSlot",
          minWidth: 120,
        },
        {
          fixed: "right",
          label: "操作",
          prop: "operation",
          slot: "operationSlot",
          width: 280,
        },
      ],
      isKeyActivity: 0,
      placementPosition: [],
      isForceRemind: 0,
      templateUrl:
        "https://cdn-image.yucrm.cn/images/dy/formTeamToShare/rldkxzmb.psd",
      saveLoading: false,
      loading: false,
      templateObj: {},
      currrentRgb: "",
      currrentRgb2: "",
      currrentRgb3: "",
      customerPaperwork: {
        title: "日历打卡", //主题
        desc: "每日打卡，可获得丰厚礼品哦~", //描述
        titleColor: "#ffffff", //主题字体颜色
        url2: "", //签到按钮背景图
        url3: "", //打卡记录图
        url4: "", //领奖按钮背景图（无曝光）
        url5: "", //领奖按钮背景图（曝光）
        signBtnColor: "#ffffff", //签到按钮字体颜色
        prizeBtnColor: "#ffffff", //领奖按钮字体颜色
      },
      actMember: "1",
      peopleSelected: [],
      templateId: "",
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      itemListFor: [], //商品弹框选择商品数据
      joinBlackList: false,
      checked: false,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      ruleForm: {
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        allowLevel: "-1",
        activityName: "",
        openCardFollow: 0,
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "",
        isValidBlackList: 0,
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: "", // 最小订单笔数
        orderCompleteMaxCount: "", // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: "", // 最小订单金额
        orderCompleteMaxPayment: "", // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: "", // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: "", // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: "", // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: "", // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)
      },
      sharePic: "https://cdn-image.yucrm.cn/hd/images/jd-calendar-checkIn.png",
      multiShopGoods: [],
      firstItemList: [],
      tableSequenceConfig: [
        "单次打卡奖品",
        "每日打卡奖品",
        "指定日期打卡奖品",
        "累计打卡奖品",
        "连续打卡奖品",
      ],
      ruleDTO: {
        signTypes: [], //打卡类型 0单次打卡 1每日打卡 2指定打卡 3累计打卡 4连续打卡
        signPattern: 0, //打卡模式 0图文打卡 1签到打卡
        isCheck: 0, //是否需要审核 0不需要 1需要
        mustOpt: [0], //设置必填项（多个逗号分割） 0-图片/视频 1-文案
        isMustBuy: 0, //是否必须购买过指定商品 0不需要 1需要
        orderStartTime: "", //下单时间开始
        orderEndTime: "", //下单时间结束
        venderIds: [],
        sellerSkuList: [],
        isAddBuyItem: false, //是否需要购买指定商品 0不需要 1需要
        multiShopSkuType: 0, //
        isStartTaskForReSignNum: 0, //是否开启做任务获得补签卡 0-否 1-是
        reSignNum: "", //可补签天数
        firstAddBuyMultiShopSkuType: 0, //前置曝光加购商品
        firstAddBuySkuBelongVenderId: "", //前置曝光加购商品所属店铺
        skuBelongVenderId: "",
        customerPaperwork: "",
        cusTemplateJSON: "",
        cusType: 0, //新老客类型
        plusObject: 0,
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "https://cdn-image.yucrm.cn/hd/images/jd-calendar-checkIn.png",
        openCardStartTime: "",
        goShopSetting: 0, //进店设置
        goShopAppId: "", //小程序appId
        goShopUrl: "", //小程序页面路径
      },
      activityStartTime: null,
      activityEndTime: null,
      templateJson: {
        templateUItype: "",
      },
      levelList: [],
      isDraft: false,
      pickerOption: {
        disabledDate: (time) => {
          //  在活动开始-结束时间范围内
          return (
            time.getTime() < new Date(this.activityStartTime).getTime() ||
            time.getTime() >
              new Date(this.activityEndTime).getTime() - 24 * 60 * 60 * 1000
          );
        },
      },
      orderStartTimePicker: {
        disabledDate: (time) => {
          return (
            (this.ruleForm.endTime
              ? time.getTime() > new Date(this.ruleForm.endTime).valueOf()
              : false) ||
            (this.ruleDTO.orderEndTime
              ? time.getTime() > new Date(this.ruleDTO.orderEndTime).valueOf()
              : false)
          );
        },
      },
      orderEndTimePicker: {
        disabledDate: (time) => {
          return (
            (this.ruleForm.endTime
              ? time.getTime() > new Date(this.ruleForm.endTime).valueOf()
              : false) ||
            (this.ruleDTO.orderStartTime
              ? time.getTime() <
                new Date(this.ruleDTO.orderStartTime).valueOf() - 8.64e7
              : false)
          );
        },
      },
      //开榜时间限制
      rankTimePicker: {
        disabledDate: (time) => {
          let start = this.activityStartTime
            ? new Date(this.activityStartTime).getTime() - 8.64e7
            : 0;
          // 结束时间限制为活动结束时间前24小时
          let end = this.activityEndTime
            ? new Date(this.activityEndTime).getTime() - 8.64e7
            : Infinity;
          let current = time.getTime();
          if (current > start && current <= end) {
            return false;
          } else {
            return true;
          }
        },
      },
    };
  },
  computed: {
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    isStartEdit() {
      return this.activityData.isStart;
    },
    backgroundImage() {
      return this.ruleDTO.cusTemplateJSON
        ? JSON.parse(this.ruleDTO.cusTemplateJSON).activityBgImg
        : this.templateObj.url;
    },
    // 开榜前是否禁用
    isDisabeldWin() {
      // 当前时间
      let currentTime = new Date().getTime();
      let flag = false;
      if (
        this.ruleDTO.rankPrizeTime &&
        this.compareTime(this.ruleDTO.rankPrizeTime) > currentTime
      ) {
        flag = false;
      } else {
        flag = this.activityData.isStart;
      }
      return flag;
    },
    venderId() {
      return this.$store.state.loginUserInfo.venderId;
    },
    shopList() {
      return this.multiShopGoods.map((item) => {
        return {
          title: item.shopTitle,
          tabKey: item.venderId,
        };
      });
    },
    newGoodsList() {
      let list = [];
      if (this.ruleDTO.sellerSkuList.length > 0) {
        const obj = this.ruleDTO.sellerSkuList.find(
          (item) => item.venderId == this.multiShopId
        );
        if (obj) {
          list = obj.itemList;
        } else {
          list = [];
        }
      }
      return list;
    },
    isGray() {
      return this.$store.getters.loginUserInfo.isGray;
    }
  },
  watch: {},
  created() {
    this.ruleDTO.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDTO.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.initData();
    this.getLevel();
    useJdCrm(this);
    this.buriedPoint(1, "日历打卡", "互动管理", "互动活动");
  },

  methods: {
    handleFirstItemSwitchChange() {
      this.firstItemList = []
      this.ruleDTO.firstOpenCardTimeType = 0;
      this.ruleDTO.firstAddBuySkuBelongVenderId = ""
    },
    changeReSignNum() {
      this.ruleDTO.reSignNum = ""
      this.taskDataList = []
    },
    addSpecifiedDateList() {
      if (this.specifiedDateList.length >= 10) {
        this.$message({
          message: "最多只能添加10个奖项",
          type: "warning",
        });
        return;
      }
      this.specifiedDateList.push({
        assetsId: null, // 资产项id(计划id优惠卷id商品id)
        prizeType: null,
        price: null,
        logo: null,
        title: "",
        totalAmount: null,
        singleAmount: "",
        calenderCheckCardSpecifiedDate: "",
        calenderCheckCardType: 2,
      });
    },
    addCumulativeCheckInList() {
      if (this.cumulativeCheckiInList.length >= 10) {
        this.$message({
          message: "最多只能添加10个奖项",
          type: "warning",
        });
        return;
      }
      this.cumulativeCheckiInList.push({
        assetsId: null, // 资产项id(计划id优惠卷id商品id)
        prizeType: null,
        price: null,
        logo: null,
        title: "",
        totalAmount: null,
        singleAmount: "",
        calenderCheckCardSpecifiedDate: "",
        calenderCheckCardType: 3,
      });
    },
    addContinuousCheckInList() {
      if (this.continuousCheckInList.length >= 10) {
        this.$message({
          message: "最多只能添加10个奖项",
          type: "warning",
        });
        return;
      }
      this.continuousCheckInList.push({
        assetsId: null, // 资产项id(计划id优惠卷id商品id)
        prizeType: null,
        price: null,
        logo: null,
        title: "",
        totalAmount: null,
        singleAmount: "",
        calenderCheckCardSpecifiedDate: "",
        calenderCheckCardType: 4,
      });
    },
    signPatternChange() {
      this.ruleDTO.isCheck = 0;
      this.ruleDTO.mustOpt = [0];
      this.ruleDTO.isMustBuy = 0;
      this.ruleDTO.orderStartTime = "";
      this.ruleDTO.orderEndTime = "";
      this.ruleDTO.sellerSkuList = [
        {
          venderId: this.venderId,
          skuIds: [],
          itemList: [],
        },
      ];
      // this.initData();
    },
    deleteProduct(index) {
      this.ruleDTO.sellerSkuList.forEach((item) => {
        if (item.venderId == this.multiShopId) {
          item.itemList.splice(index, 1);
          item.skuIds.splice(index, 1);
        }
      });
    },
    changeShop(list) {
      if (list.length == 1) {
        this.multiShopId = list[0].venderId;
      } else if (list.length > 1 && !list.includes(+this.multiShopId)) {
        this.multiShopId = list[0].venderId;
      }
    },
    selectGoodsCloseFilter(data) {
      if (data) {
        this.ruleDTO.sellerSkuList.forEach((item) => {
          if (item.venderId == this.multiShopId) {
            item.itemList = []
          }
        });
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.jdPrice = data[index].jdPrice || data[index].price;
          fomeVaule.skuName = data[index].wareTitle || data[index].title;

          this.ruleDTO.sellerSkuList.forEach((item) => {
            if (item.venderId == this.multiShopId) {
              item.itemList.push(fomeVaule);
              item.skuIds.push(fomeVaule.skuId);
            }
          });
        });
        let list = this.ruleDTO.sellerSkuList.filter(
          (item) => item.venderId == this.multiShopId
        );
        this.selectGoodsFilterArr = list.length > 0 ? list[0].itemList : [];
      }
      this.isShowSelect = false;
    },
    addProduct() {
      this.isShowSelect = true;
      this.selectGoodsFilterArr = this.newGoodsList;
    },
    getShopList(row) {
      this.multiShopId = row.name;
    },
    initData() {
      this.multiShopId = this.venderId;
      this.ruleDTO.venderIds = [this.venderId];
      this.ruleDTO.sellerSkuList = [
        {
          venderId: this.venderId,
          skuIds: [],
          itemList: [],
        },
      ];
      this.multiShopGoods = useValidateMultiShopGoods(this, [this.venderId]);
    },
    handleWinTypeChange(row, index) {
      row.scoreRankWinConditionDTO.rankStart = "";
      row.scoreRankWinConditionDTO.rankEnd = "";
      row.scoreRankWinConditionDTO.rankNum = "";
    },
    synchronization() {
      if (!this.ruleForm.startTime) {
        return this.$message.warning("请先选择活动开始时间");
      }
      if (!this.ruleForm.endTime) {
        return this.$message.warning("请先选择活动结束时间");
      }
      this.ruleDTO.orderStartTime = this.ruleForm.startTime;
      this.ruleDTO.orderEndTime = this.ruleForm.endTime;
    },
    compareTime(time) {
      return new Date(time).getTime();
    },
    clearShowRankTime() {
      this.ruleDTO.rankPrizeTime = "";
    },
    changeJoinType() {
      this.ruleDTO.participateTimeStart = "";
      this.ruleDTO.participateTimeEnd = "";
    },
    // 输入时只做数字过滤，不做大小比较，避免输入过程中被清空
    filterRankNumber(val, row, field) {
      let filtered = val.replace(/^0|[^\d]/g, "");
      let num = Number(filtered);
      if (num < 1) {
        filtered = "";
      }
      row.scoreRankWinConditionDTO[field] = filtered;
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },
    onShopSetChange(value) {
      this.ruleDTO.goShopAppId = "";
      this.ruleDTO.goShopUrl = "";
    },
    resetRgb(row) {
      this.currrentRgb = row.rgb;
      this.currrentRgb2 = row.rgb2;
      this.currrentRgb3 = row.rgb3;
    },
    initCustomizeData(row) {
      this.customerPaperwork.titleColor = row.rgb || "#ffffff";
      this.customerPaperwork.signBtnColor = row.rgb2 || "#ffffff";
      this.customerPaperwork.prizeBtnColor = row.rgb3 || "#ffffff";
      this.resetRgb(row);
    },
    selectTemplate(index, id, item) {
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      this.initCustomizeData(item);
    },

    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.loading = false;
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
              return {
                ...item,
                days: item.activityStartTime
                  ? this.getDaysBetween(
                      item.activityStartTime,
                      item.activityEndTime
                    )
                  : "",
              };
            })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        let obj = this.giftList[0];
        this.templateObj = obj;
        this.templateId = obj.id;
        this.templateJson.templateUItype = 0;
        this.initCustomizeData(this.templateObj);
      } else if (this.templateId) {
        let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.templateObj = arr[0];
        this.templateId = this.templateId;
        this.resetRgb(this.templateObj);
      }
      this.pageData.total = data.total * 1;
    },
    //会员等级
    getLevel() {
      if (this.valueRow && this.valueRow.id) {
        this.loading = true;
      }
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          this.getDetail();
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    //生成规则
    generateRule() {
      let text1 = "打卡类型:",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "",
        text9 = "",
        secondText = "\n二、【活动参与规则】",
        thirdText = "\n三、【活动奖品】",
        fourthText = "\n四、【注意事项】";
      let numberMap = {
        0: "①",
        1: "②",
        2: "③",
        3: "④",
        4: "⑤",
        5: "⑥",
        6: "⑦",
        7: "⑧",
        8: "⑨",
        9: "⑩",
      };
      this.ruleDTO.signTypes.forEach((item, index) => {
        if (index != 0) {
          text1 += "、";
        }
        if (item == 0) {
          text1 += "单次打卡";
        }
        if (item == 1) {
          text1 += "每日打卡";
        }
        if (item == 2) {
          text1 += "指定日期打卡";
        }
        if (item == 3) {
          text1 += "累计打卡";
        }
        if (item == 4) {
          text1 += "连续打卡";
        }
      });
      if (this.ruleDTO.signPattern == 0) {
        text2 = `是否需要审核：${
          this.ruleDTO.isCheck == 1 ? "需要商家审核" : "不需要商家审核"
        }`;
        text3 = `必填项：图片/视频 ${
          this.ruleDTO.mustOpt.includes(1) ? "、文案" : ""
        }`;
        text4 =
          this.ruleDTO.isMustBuy == 1
            ? `商品购买限制：用户必须在指定时间范围内购买过指定商品，才可以参与活动`
            : "";
      }
      if (this.ruleDTO.signTypes.includes(0)) {
        text5 = `单次打卡礼品:完成 1 次打卡，可领取奖品${this.oneTimeList[0].title},共${this.oneTimeList[0].totalAmount}份,单份奖品价值${this.oneTimeList[0].price}元`;
      }
      if (this.ruleDTO.signTypes.includes(1)) {
        text6 = `每日打卡礼品:每天完成打卡，可领取奖品${this.dayTimeList[0].title},共${this.dayTimeList[0].totalAmount}份,单份奖品价值${this.dayTimeList[0].price}元`;
      }
      if (this.ruleDTO.signTypes.includes(2)) {
        text7 = `指定打卡礼品:\n`;
        this.specifiedDateList.forEach((item, index) => {
          text7 +=
            `${numberMap[index]}.${item.calenderCheckCardSpecifiedDate}当天打卡，可领取奖品${item.title},共${item.totalAmount}份,单份奖品价值${item.price}元` +
            (index == this.specifiedDateList.length - 1 ? "" : "\n");
        });
      }
      if (this.ruleDTO.signTypes.includes(3)) {
        text8 = `累计打卡礼品：\n`;
        this.cumulativeCheckiInList.forEach((item, index) => {
          text8 +=
            `${numberMap[index]}.累计打卡 ${item.calenderCheckCardTimes} 天，可领取奖品${item.title},共${item.totalAmount}份,单份奖品价值${item.price}元` +
            (index == this.cumulativeCheckiInList.length - 1 ? "" : "\n");
        });
      }
      if (this.ruleDTO.signTypes.includes(4)) {
        text9 = `连续打卡礼品:\n`;
        this.continuousCheckInList.forEach((item, index) => {
          text9 +=
            `${numberMap[index]}.连续打卡 ${item.calenderCheckCardTimes} 天，可领取奖品${item.title},共${item.totalAmount}份,单份奖品价值${item.price}元` +
            (index == this.continuousCheckInList.length - 1 ? "" : "\n");
        });
      }
      const { firstText, precautions } = this.getCommonText(
        this.levelList,
        this.ruleForm,
        this.ruleDTO,
        this.actMember
      );
      let Arr1 = [
        firstText,
        [secondText, text1, text2, text3, text4],
        [thirdText, text5, text6, text7, text8, text9],
        [fourthText, precautions],
      ];
      let newText = "";
      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText.trim();
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },

    // 下一步
    resetForm() {
      // 公共校验
      if (!useValidateBasicInformation(this)) {
        return;
      }
      if (this.ruleDTO.signTypes.length == 0) {
        this.$message.warning("请选择打卡类型");
        return;
      }
      if (this.ruleDTO.signPattern == 0) {
        const obj = this.ruleDTO.sellerSkuList.find(
          (item) => item.skuIds.length == 0
        );
        if (obj) {
          const shop = this.multiShopGoods.find(
            (item) => item.venderId == obj.venderId
          );
          this.$message.warning(`请选择${shop.shopTitle}的关联商品`);
          return;
        }
        if (
          this.ruleDTO.isMustBuy == 1 &&
          (!this.ruleDTO.orderStartTime || !this.ruleDTO.orderEndTime)
        ) {
          this.$message.warning("请选择下单时间");
          return;
        }

        if (this.ruleDTO.isMustBuy == 1) {
          if (
            new Date(this.ruleForm.startTime).getTime() >
            new Date(this.ruleDTO.orderStartTime).getTime()
          ) {
            this.$message.warning("下单时间不能早于活动开始时间");
            return;
          }
          if (
            new Date(this.ruleForm.endTime).getTime() <
            new Date(this.ruleDTO.orderEndTime).getTime()
          ) {
            this.$message.warning("下单时间不能晚于活动结束时间");
            return;
          }
        }
      }
      if (this.ruleDTO.signTypes.includes(0)) {
        // let isTrue = true;
        // this.oneTimeList.forEach((item) => {
        //   if (!item.prizeType || !item.title || !item.totalAmount) {
        //     isTrue = false;
        //   }
        // });
        let isTrue = useValidatePrizeInformation(this, "oneTimeList");
        if (!isTrue) {
          this.$message.warning("请完善单次打卡奖品");
          return;
        }
      }

      if (this.ruleDTO.signTypes.includes(1)) {
        // let isTrue = true;
        // this.dayTimeList.forEach((item) => {
        //   if (!item.prizeType || !item.title || !item.totalAmount) {
        //     isTrue = false;
        //   }
        // });
        let isTrue = useValidatePrizeInformation(this, "dayTimeList");
        if (!isTrue) {
          this.$message.warning("请完善单每日打卡奖品");
          return;
        }
      }

      if (this.ruleDTO.signTypes.includes(2)) {
        let isTrue = true;
        let message = "请完善指定日期打卡奖品";
        const dateSet = new Set();
        this.specifiedDateList.forEach((item) => {
          if (
            !item.prizeType ||
            !item.title ||
            !item.totalAmount ||
            !item.calenderCheckCardSpecifiedDate
          ) {
            isTrue = false;
          }
          if (
            new Date(this.ruleForm.startTime).getTime() - 8.64e7 >
              new Date(item.calenderCheckCardSpecifiedDate).getTime() ||
            new Date(this.ruleForm.endTime).getTime() <
              new Date(item.calenderCheckCardSpecifiedDate).getTime()
          ) {
            message = `指定日期打卡不可${
              new Date(this.ruleForm.startTime).getTime() >
              new Date(item.calenderCheckCardSpecifiedDate).getTime()
                ? "前"
                : "超"
            }过活动时间范围`;
            isTrue = false;
          }
        });
        if (!isTrue) {
          this.$message.warning(message);
          return;
        }
        this.specifiedDateList.forEach((item) => {
          // 检查日期是否重复
          const dateStr = item.calenderCheckCardSpecifiedDate;
          if (dateSet.has(dateStr)) {
            message = `该日期已被选择，请选择其他日期`;
            isTrue = false;
          } else {
            dateSet.add(dateStr);
          }
        });
        if (!isTrue) {
          this.$message.warning(message);
          return;
        }
      }

      if (this.ruleDTO.signTypes.includes(3)) {
        let isTrue = true;
        let message = "";
        this.cumulativeCheckiInList.forEach((item) => {
          if (
            !item.prizeType ||
            !item.title ||
            !item.totalAmount ||
            !item.calenderCheckCardTimes
          ) {
            isTrue = false;
          }
        });
        if (!isTrue) {
          this.$message.warning("请完善累计打卡奖品");
          return;
        }
        for (let i = 1; i < this.cumulativeCheckiInList.length; i++) {
          const prevTimes =
            this.cumulativeCheckiInList[i - 1].calenderCheckCardTimes;
          const currTimes =
            this.cumulativeCheckiInList[i].calenderCheckCardTimes;
          if (Number(currTimes) < Number(prevTimes)) {
            message = `下一个累计打卡天数需大于上一累计打卡天数`;
            isTrue = false;
            break;
          }
        }
        if (!isTrue) {
          this.$message.warning(message);
          return;
        }
      }

      if (this.ruleDTO.signTypes.includes(4)) {
        let isTrue = true;
        let message = "请完善连续打卡奖品";
        this.continuousCheckInList.forEach((item) => {
          if (
            !item.prizeType ||
            !item.title ||
            !item.totalAmount ||
            !item.calenderCheckCardTimes
          ) {
            isTrue = false;
          }
        });
        if (!isTrue) {
          this.$message.warning(message);
          return;
        }
        // 检查calenderCheckCardTimes是否逐级递增
        for (let i = 1; i < this.continuousCheckInList.length; i++) {
          const prevTimes =
            this.continuousCheckInList[i - 1].calenderCheckCardTimes;
          const currTimes =
            this.continuousCheckInList[i].calenderCheckCardTimes;
          console.log(prevTimes, currTimes);
          if (Number(currTimes) < Number(prevTimes)) {
            message = `下一个连续打卡天数需大于上一连续打卡天数`;
            isTrue = false;
            break;
          }
        }
        if (!isTrue) {
          this.$message.warning(message);
          return;
        }
      }
      if (
        this.ruleDTO.isStartTaskForReSignNum == 1 &&
        this.taskDataList.length == 0
      ) {
        this.$message.warning("请添加任务");
        return;
      }
      if (this.ruleDTO.isAddBuyItem && !this.firstItemList.length) {
        this.$message.warning("请添加前置曝光加购商品");
        return;
      }

      if (!useValidateActEndInfomation(this, false)) {
        return;
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    async handleDialogCloseAnoth() {
      const obj = useInputBasicInformation(this, 84);
      // 打卡类型
      obj.ruleDTO.signTypes = this.ruleDTO.signTypes.join(",");
      // 设置必填项
      obj.ruleDTO.mustOpt = this.ruleDTO.mustOpt.join(",");
      // 前置曝光商品
      obj.firstItemList = this.firstItemList;
      obj.ruleDTO.firstAddBuySkuBelongVenderId =
        this.ruleDTO.firstAddBuyMultiShopSkuType == 0 &&
        this.firstItemList.length > 0
          ? this.firstItemList[0].belongVenderId
          : "";
          obj.ruleDTO.skuBelongVenderId =
        this.ruleDTO.multiShopSkuType == 0 &&
        this.itemListFor.length > 0
          ? this.itemListFor[0].belongVenderId
          : "";
      // 关联店铺商品处理
      obj.ruleDTO.sellerSkuList = this.ruleDTO.sellerSkuList.map((item) => {
        return {
          skuIds: item.skuIds,
          venderId: item.venderId,
        };
      });
      // 奖品处理
      let prizeListCommon = [];
      if (this.ruleDTO.signTypes.includes(0)) {
        this.oneTimeList.forEach((item) => {
          if (item.prizeType !== null && item.prizeType) {
            prizeListCommon.push(item);
          }
        });
      }
      if (this.ruleDTO.signTypes.includes(1)) {
        this.dayTimeList.forEach((item) => {
          if (item.prizeType !== null && item.prizeType) {
            prizeListCommon.push(item);
          }
        });
      }
      if (this.ruleDTO.signTypes.includes(2)) {
        this.specifiedDateList.forEach((item) => {
          if (item.prizeType !== null && item.prizeType) {
            prizeListCommon.push(item);
          }
        });
      }
      if (this.ruleDTO.signTypes.includes(3)) {
        this.cumulativeCheckiInList.forEach((item) => {
          if (item.prizeType !== null && item.prizeType) {
            prizeListCommon.push(item);
          }
        });
      }
      if (this.ruleDTO.signTypes.includes(4)) {
        this.continuousCheckInList.forEach((item) => {
          if (item.prizeType !== null && item.prizeType) {
            prizeListCommon.push(item);
          }
        });
      }
      obj.pointActivityPrizeDTOList = prizeListCommon;
      // 任务
      if (this.taskDataList.length) {
        obj.taskList = useInputTaskData(this.taskDataList);
      } else {
        obj.taskList = [];
      }
      if (this.checked == true || this.isDraft) {
        this.saveLoading = true;
        if (this.activityData.isStart) {
          const params = useUpdateBasicInformation(obj, prizeListCommon, this);
          updateCommon(params)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        } else {
          if (this.isDraft) {
            obj.status = 5;
            delete obj.templateJson;
          } else {
            // 保存正式活动不需要status
            if (obj.status) delete obj.status;
            if (!this.activityData.isCopy) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
                obj.id = this.valueRow.id;
              }
            } else {
              delete obj.templateJson;
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
            // 草稿箱保存正式活动删除id
            if (!obj.status) {
              delete obj.id;
            }
          }
          saveOrUpdateCalendarCheckIn(obj)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        }
      } else {
        this.saveLoading = false;
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        getCalendarCheckInDetail({ id: this.valueRow.id })
          .then((res) => {
            const {
              pointActivityPrizeDTOList,
              taskList,
              firstItemList,
              ruleDto,
            } = res.data;
            this.isCreated = true;
            this.firstItemList = firstItemList;
            useOutputBasicInformation(res.data, this);
            this.ruleDTO.signTypes =
              res.data.ruleDto.signTypes
                .split(",")
                .map((item) => Number(item)) || [];
            this.ruleDTO.mustOpt =
              res.data.ruleDto.mustOpt.split(",").map((item) => Number(item)) ||
              [];
            this.ruleDTO.sellerSkuList = ruleDto.sellerSkuList.map((item) => {
              return {
                ...item,
                itemList: [],
              };
            });
            this.ruleDTO.venderIds =
              this.ruleDTO.venderIds && this.ruleDTO.venderIds.length > 0
                ? this.ruleDTO.venderIds
                : [this.venderId];
            if (this.activityData.isCopy||this.isDraftEdit) {
              // 跨店复制
              if(this.ruleDTO.venderIds.length>0) {
                let index = this.ruleDTO.venderIds.findIndex((item)=>{
                  return item == this.venderId
                })
                if(index==-1) {
                  this.ruleDTO.venderIds.unshift(Number(this.venderId))
                  this.ruleDTO.sellerSkuList.unshift({
                    venderId: Number(this.venderId),
                    skuIds: [],
                    itemList: [],
                  })
                }
              }
            } 
            if(this.isGray) {
              this.ruleDTO.sellerSkuList = this.ruleDTO.sellerSkuList.filter((item)=>item.venderId==this.venderId);
              this.ruleDTO.venderIds = [this.venderId]
            }
            this.ruleDTO.sellerSkuList.forEach((item) => {
              if (item.skuIds.length > 0) {
                getTaobaoItemListSku({
                  current: 1,
                  size: item.skuIds.length,
                  skuIds: item.skuIds,
                  venderId: item.venderId,
                }).then((res) => {
                  item.itemList =
                    res.data.records.length > 0 ? res.data.records : [];
                });
              }
            });
            this.multiShopGoods = useValidateMultiShopGoods(this, this.ruleDTO.venderIds);
            if (!this.activityData.isCopy) {
              let mapCalenderCheckCardType = {
                0: "oneTimeList",
                1: "dayTimeList",
                2: "specifiedDateList",
                3: "cumulativeCheckiInList",
                4: "continuousCheckInList",
              };
              if(pointActivityPrizeDTOList&&pointActivityPrizeDTOList.length >0) {
                // 奖品回显
                pointActivityPrizeDTOList.forEach((item) => {
                  this[mapCalenderCheckCardType[item.calenderCheckCardType]] = [];
                });
                pointActivityPrizeDTOList.forEach((item) => {
                  this[mapCalenderCheckCardType[item.calenderCheckCardType]].push(
                    item
                  );
                });
              }
            }
            // 任务回显
            if (taskList.length > 0) {
              this.taskDataList = useOutputTaskData(taskList, this);
            }
            if(this.ruleDTO.isStartTaskForReSignNum == 1 && this.isStartEdit) {
              this.isStartTaskForReSignNumDisabled = true
            }
            this.getPolite();
          })
          .catch((res) => {});
      } else {
        this.activityStartTime = this.$getDate(30)[0];
        this.activityEndTime = this.$getDate(30)[1];
        this.hdTaskTemplateGroup();
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
  }
  .showTip {
    color: red;
    font-size: 14px;
  }
  .openTip {
    margin-left: 8px;
    color: #333333;
  }
  .rule_box {
    background-color: #f7f8fa;
    padding: 16px 16px 1px;
    border-radius: 4px;
    font-size: 14px;
  }
  .upload-box {
    width: 450px;
    padding: 20px 20px 1px;
    background: #f4f6fa;
    border-radius: 4px;
  }
  .prize-box {
    background: #fafafa;
    padding: 20px 20px 20px 0;
    border-radius: 4px;

    &-item {
      background: #fff;
      padding: 20px 20px 5px 0;
      border-radius: 4px;
    }
  }
  .product-image-cell {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
  }

  .product-thumb {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 4px;
  }
}

.ml4 {
  margin-left: 4px;
}

.ml8 {
  margin-left: 8px;
}

.mlr8 {
  margin: 0 8px;
}

.ml16 {
  margin-left: 16px;
}

.w100 {
  width: 100px;
}
.w80 {
  width: 80px;
}
.w200 {
  width: 200px;
}
.w60 {
  width: 60px;
}
.w145 {
  width: 145px;
}

.flex-c {
  display: flex;
  flex-direction: column;
}
.flex-r {
  display: flex;
  align-items: center;
}
/deep/ .el-tooltip__popper {
  font-size: 14px !important;
}

.tip-style {
  color: #333333;
}
</style>
